"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMarkdownUsageInformation = exports.flattenTokenTree = exports.wrapSupportedPhonesWithLinkMarkdown = undefined;

var _wrapSupportedPhonesWithLinkMarkdown = require("./wrapSupportedPhonesWithLinkMarkdown");

Object.defineProperty(exports, "wrapSupportedPhonesWithLinkMarkdown", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_wrapSupportedPhonesWithLinkMarkdown).default;
    }
});

var _markdownItConfiguration = require("./markdownItConfiguration");

var _supportedPhoneNumbersRegexp = require("./supportedPhoneNumbersRegexp");

var _supportedPhoneNumbersRegexp2 = _interopRequireDefault(_supportedPhoneNumbersRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenTokenTree = exports.flattenTokenTree = function flattenTokenTree(tokens) {
    if (!tokens) {
        return [];
    }
    var allChildTokes = tokens.map(function (x) {
        return flattenTokenTree(x.children);
    }).reduce(function (a, b) {
        return a.concat(b);
    }, []);
    return tokens.concat(allChildTokes);
};

var getMarkdownUsageInformation = exports.getMarkdownUsageInformation = function getMarkdownUsageInformation(text) {
    var configuredMarkdownIt = _markdownItConfiguration.linkifiedMarkdownItConfiguration;
    var parsedTree = configuredMarkdownIt.parse(text, {});
    var flattenedTokenTree = flattenTokenTree(parsedTree);

    return {
        containsStrikethrough: flattenedTokenTree.some(function (x) {
            return x.type === 's_open';
        }),
        containsBold: flattenedTokenTree.some(function (x) {
            return x.type === 'strong_open';
        }),
        containsItalics: flattenedTokenTree.some(function (x) {
            return x.type === 'em_open';
        }),
        containsLink: flattenedTokenTree.some(function (x) {
            return x.type === 'link_open';
        }),
        containsOrderedList: flattenedTokenTree.some(function (x) {
            return x.type === 'ordered_list_open';
        }),
        containsUnorderedList: flattenedTokenTree.some(function (x) {
            return x.type === 'bullet_list_open';
        }),
        containsPhone: _supportedPhoneNumbersRegexp2.default.test(text),
        containsEmoji: flattenedTokenTree.some(function (x) {
            return x.type === 'emoji';
        })
    };
};

exports.default = function (text) {
    var configuredMarkdownIt = _markdownItConfiguration.linkifiedMarkdownItConfiguration;
    return configuredMarkdownIt.parse(text, {});
};